var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgAlertDefault = function SvgAlertDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": true,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.613 0 8c0 4.42 3.58 8 8 8 4.387 0 8-3.58 8-8 0-4.387-3.613-8-8-8m0 14.452A6.43 6.43 0 0 1 1.548 8 6.45 6.45 0 0 1 8 1.548c3.548 0 6.452 2.904 6.452 6.452A6.45 6.45 0 0 1 8 14.452m1.355-3.355c0-.742-.613-1.355-1.355-1.355-.774 0-1.355.613-1.355 1.355 0 .774.58 1.355 1.355 1.355.742 0 1.355-.581 1.355-1.355M6.71 4.29l.225 4.387c0 .194.194.355.388.355h1.322c.194 0 .387-.161.387-.355l.226-4.387c0-.225-.161-.419-.387-.419H7.097c-.226 0-.387.194-.387.42"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertDefault);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;